import { apiSlice } from "./ApiSlice";

const AddClinicInfoApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    AddClinic: builder.mutation({
      query: (credentials) => {
        return {
          url: "/api/ClinicProfile/AddClinicInfo",
          method: "POST",
          body: credentials,
        };
      },
    }),

    GetDashboardGeneral: builder.query({
  query: (clinicId) => ({
    url: `api/ClinicProfile/ClinicDashboardData?userClinicId=${clinicId}`,
    method: "GET",
  }),
}),

    GetAllClinicDashboard: builder.query({
      query: ({ clinicId, appointmentDate }) => ({
        url: `api/ClinicProfile/ClinicDashboardData?userClinicId=${clinicId}&appointmentDate=${appointmentDate}`,
        method: "GET",
      }),
    }),

    Getallclinicinfo: builder.query({
      query: (uniqueUserId) => {
        return {
          url: `/api/ClinicProfile/GetClinicInfo?userUniqueId=${uniqueUserId}`,
          method: "GET",
        };
      },
    }),

    Getallclinics: builder.query({
      query: () => {
        return {
          url: `/api/ClinicProfile/GetClinicListView`,
          method: "GET",
        };
      },
    }),

    Getclinic: builder.query({
      query: (clinicId) => {
    
        return {
          url: `/api/ClinicProfile/GetClinicInfo?userUniqueId=${clinicId}`,
          method: "GET",
        };
      },
    }),

    TermsAgree: builder.mutation({
      query: (credentials) => {
        return {
          url: "/api/ClinicProfile/addtermsandconditions",
          method: "POST",
          body: credentials,
        };
      },
    }),
    getTandCClinicsList: builder.query({
      query: () => {
        return {
          url: "/api/ClinicProfile/ListofClinics-TermsandConditions",
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useAddClinicMutation,
  useLazyGetallclinicinfoQuery,
  useGetDashboardGeneralQuery,
  useGetAllClinicDashboardQuery,
  useLazyGetallclinicsQuery,
  useLazyGetclinicQuery,
  useTermsAgreeMutation,
  useGetTandCClinicsListQuery
} = AddClinicInfoApiSlice;
